import { render, staticRenderFns } from "./TableAbstract.vue?vue&type=template&id=b7772cdc&scoped=true&"
import script from "./TableAbstract.vue?vue&type=script&lang=js&"
export * from "./TableAbstract.vue?vue&type=script&lang=js&"
import style0 from "./TableAbstract.vue?vue&type=style&index=0&id=b7772cdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7772cdc",
  null
  
)

export default component.exports